package com.bulut.mecitogullari.data.model

import kotlinx.serialization.Serializable

@Serializable
enum class UnitStatus {
    /** Satılık */
    AVAILABLE,

    /** Rezerve */
    RESERVED,

    /** Satıldı */
    SOLD,
}

/** One installment received for a sold unit; mirrored into the ledger. */
@Serializable
data class UnitPayment(
    val id: String,
    @Serializable(with = LongAsDoubleSerializer::class)
    val dateEpochMillis: Long,
    val amount: Double,
)

/** One apartment in a project's building grid. */
@Serializable
data class ApartmentUnit(
    val id: String,
    val projectId: String,
    /** Block name ("A", "B"…). Blank on single-block projects. */
    val block: String = "",
    /** 1-based floor, 1 = ground floor. */
    val floor: Int,
    /** 1-based position on the floor. */
    val indexOnFloor: Int,
    /** Building-wide apartment number ("Daire 7"). */
    val number: Int,
    val status: UnitStatus = UnitStatus.AVAILABLE,
    val salePrice: Double? = null,
    /** UTC-midnight epoch millis; set when the unit is marked SOLD. */
    @Serializable(with = LongAsDoubleSerializer::class)
    val saleDateEpochMillis: Long? = null,
    val buyerName: String = "",
    val buyerPhone: String = "",
    val notes: String = "",
    /** Installments received; each one is a ledger income entry. */
    val payments: List<UnitPayment> = emptyList(),
    /** Set when the unit was given as barter (iş karşılığı) — no cash income. */
    val barterCraftsmanId: String? = null,
) {
    /** "D7" / "A-D7" on multi-block projects. */
    val label: String get() = if (block.isBlank()) "D$number" else "$block-D$number"

    val paidTotal: Double get() = payments.sumOf { it.amount }

    /** Outstanding buyer debt for a sold unit. */
    val remaining: Double get() = ((salePrice ?: 0.0) - paidTotal).coerceAtLeast(0.0)
}
